import React from 'react';
import PropTypes from 'prop-types';
import OutsourceTreeItemDetail from "./OutsourceTreeItemDetail";

export default class OutsourceTreeDetail extends React.Component {

  static renderLabelClass(level){
    let className = 'label';
    switch (level){
      case 1:
        className += ' bg-orange';
        break;
      case 2:
        className += ' bg-grey';
        break;
      case 3:
        className += ' bg-brown';
        break;
      default:
        break;
    }
    return className;
  }

  renderChildren(children){
    return children.map((contract, i) => {
      return(
        <OutsourceTreeItemDetail key={i} contract={contract}/>
      );
    });
  }

  render() {
    if (!this.props.contracts){
      return null;
    }
    return (
      <div className="work-tree">
        <ul>
          {this.props.contracts.map((contract, i) => {
            return(
              <li key={i}>
                <div className="row this-company">
                  <div className="col-xs-1">
                    <span className={contract.company && contract.company.level ? OutsourceTreeDetail.renderLabelClass(contract.company.level) : ''}>
                      {contract.company && contract.company.level ? contract.company.level : ''}
                    </span>
                  </div>
                  <div className="col-xs-10">
                    <p>{contract.company ? contract.company.name : ''}</p>
                  </div>

                </div>

                <ul>
                  {this.renderChildren(contract.children)}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

}


OutsourceTreeDetail.propTypes = {
  contracts: PropTypes.array
};

OutsourceTreeDetail.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/works/components/OutsourceTreeDetail.js